import { Typography } from '@mui/material';

export const EventItemText = ({
  text,
  fontWeight = 400,
}: {
  text: string;
  fontWeight?: number;
}) => {
  return (
    <Typography
      noWrap
      sx={{
        fontFamily: 'Inter',
        fontWeight,
        fontSize: '14px',
        lineHeight: '122%',
        color: '#23252F',
      }}
    >
      {text}
    </Typography>
  );
};
